module.exports = Promise.all([__parcel__import__("eXTor"), __parcel__import__("llk8p"), __parcel__import__("addBY")]).then(() => parcelRequire('g36Vt'));